import React from 'react';
import { ProductLinePanier } from 'components/molecules/Panier/ProductLinePanier';
import { CartHeader } from 'components/molecules/Panier/CartHeader';
import { Divider } from 'components/atoms/Dividers/Divider';
import { orderByCommandeLinePanier } from 'helpers/filters/orderBy';
import { CommandeLinePanier } from '../../types/commandeLine/commandeLine.def';

interface ProduitDetailProps {
  commandelines: CommandeLinePanier[];
}

const ProduitDetail = ({ commandelines }: ProduitDetailProps) => {
  const commandeLines =
    commandelines && orderByCommandeLinePanier(commandelines, 'asc');
  return (
    <div>
      <CartHeader />
      <Divider />
      {commandeLines?.map(
        (commandeline, index) =>
          commandeline.produit && (
            <div key={index}>
              <ProductLinePanier
                line={commandeline}
                onClickTrash={null}
                onClickViewMore={null}
                hideButtons={true}
              />
              <Divider />
            </div>
          )
      )}
      <p>
        {commandeLines.length} article{commandeLines.length > 1 && 's'}
      </p>
    </div>
  );
};
export default ProduitDetail;
